import Swiper from "swiper";
import { Pagination } from "swiper/modules";

function setupTestimonials(testimonialsSection) {
	const totalSlides = parseInt(testimonialsSection?.dataset.totalSlides, 10);

	if (totalSlides > 0) {
		new Swiper(".swiper-container", {
			initialSlide: 1,
			centeredSlides: true,
			freeMode: true,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			modules: [Pagination],
			breakpoints: breakpoints,
		});
	}
}

const breakpoints = {
	320: {
		slidesPerView: 1,
		spaceBetween: 10,
	},
	768: {
		slidesPerView: 2.25,
		spaceBetween: 30,
	},
};

window.addEventListener("DOMContentLoaded", setupTestimonials);

// let testimonialsSection = document.querySelector(".testimonials-section");

// if (testimonialsSection) {
// 	setupTestimonials(testimonialsSection);
// } else {
// 	const testimonialsInterval = setInterval(() => {
// 		testimonialsSection = document.querySelector(".testimonials-section");

// 		if (testimonialsSection) {
// 			clearInterval(testimonialsInterval);
// 			setupTestimonials(testimonialsSection);
// 		}
// 	}, 64);
// }
